import CompanyOmsIndex from "@/components/oms/company/CompanyOmsIndex.vue";
import CompanyOmsAdd from "@/components/oms/company/CompanyOmsAdd.vue";
import CompanyOmsDetail from "@/components/oms/company/CompanyOmsDetail.vue";
import CompanyOmsEdit from "@/components/oms/company/CompanyOmsEdit.vue";
import CompanyOmsUpload from "@/components/oms/company/CompanyOmsUpload.vue";

let routesCompanyOmsAccess= [
    {
        path: '',
        meta: {
          title: "List Company Access",
        },
        name: "CompanyOmsIndex",
        component: CompanyOmsIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Company Access",
        },
        name: "CompanyOmsAdd",
        component: CompanyOmsAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Company Access",
        },
        name: "CompanyOmsDetail",
        component: CompanyOmsDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Company Access",
        },
        name: "CompanyOmsEdit",
        component: CompanyOmsEdit
    },
     
    {
        path: 'upload',
        meta: {
          title: "Upload Company Access",
        },
        name: "CompanyOmsUpload",
        component: CompanyOmsUpload
    },
    
]

export default routesCompanyOmsAccess
  